import React, { useContext } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useSchools from '../../hooks/useSchools';
import styles from '../HomePageForm/HomePageForm.module.sass';
import { CustomerContext } from '../../contexts/CustomerContext';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#000' : '#777',
    fontFamily: 'inherit',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#777',
    fontFamily: 'inherit',
    fontSize: '0.95em',
  }),
};

const SchoolInput = ({ onChange }) => {
  const schools = useSchools();
  const { customer } = useContext(CustomerContext);

  return (
    <label htmlFor="school-input" className={styles.label}>
      School Name
      <Select
        id="school-input"
        defaultValue={customer.currentSchool ? { value: customer.currentSchool.id, label: customer.currentSchool.name } : ''}
        options={schools.map((selectSchool) => (
          ({ value: selectSchool.id, label: selectSchool.name })
        ))}
        className={styles.schoolInput}
        styles={customStyles}
        onChange={onChange}
      />
    </label>
  );
};

SchoolInput.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default SchoolInput;
